import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api_url } from "../../helpers/apiHelpers";
import { Link, useNavigate } from "react-router-dom";
import { Edit, Eye } from "lucide-react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import moment from "moment";

const UsersData = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [allUsersData, setAllUsersData] = useState([]);
  const [filterUsersData, setFilterUsersData] = useState([]);

  const [query, setQuery] = useState("");

  const getAllData = async () => {
    try {
      const response = await fetch(`${api_url}/api/admin/get-users-data`);
      const result = await response.json();

      if (result.status === 201) {
        setAllUsersData(result.result);
        setFilterUsersData(result.result);
      } else {
        setAllUsersData([]);
        setFilterUsersData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setAllUsersData([]);
      setFilterUsersData([]);
    }
  };

  const handleFilterData = (query) => {
    const lowerCaseQuery = query.toLowerCase();
    const filteredItems = allUsersData.filter((admin) => {
      return (
        admin.fullName.toLowerCase().includes(lowerCaseQuery) ||
        admin.officeName.toLowerCase().includes(lowerCaseQuery) ||
        admin.email.toLowerCase().includes(lowerCaseQuery) ||
        admin.mobile.includes(lowerCaseQuery)
      );
    });

    setFilterUsersData(filteredItems);
  };

  useEffect(() => {
    getAllData();
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filterUsersData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filterUsersData.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const setUserLogin = (id) => {
    const userData = allUsersData.find((user) => user._id === id);
    localStorage.setItem("userId", userData._id);
    localStorage.setItem("userName", userData.fullName);
    localStorage.setItem("userEmail", userData.email);
    navigate("/dashboard/dashboard");
  };

  return (
    <div className="flex-1 overflow-auto relative z-10 p-4">
      <div className="row">
        <div className="col-lg-8 col-8">
          <h2 className="mb-3 font-semibold text-2xl text-black text-center bg-[#c6e920] py-1 rounded-lg shadow-lg transition-transform duration-300">
            See All Users Of Digital Parag
          </h2>
        </div>
        <div className="col-lg-4 col-4">
          <div className="input-group mb-3">
            <span className="input-group-text" id="basic-addon1">
              <i className="fas fa-search"></i>
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Search..."
              value={query}
              onChange={(e) => {
                setQuery(e.target.value);
                handleFilterData(e.target.value);
              }}
            />
          </div>
        </div>
      </div>
      <div className="mx-0">
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          className="overflow-x-auto w-full max-w-[22rem] sm:max-w-full"
        >
          <table className="table table-bordered table-responsive text-left">
            <thead>
              <tr className="bg-gradient-to-r from-orange-100 to-orange-300">
                <th>#</th>
                <th>Date</th>
                <th>Name</th>
                <th>Office Name</th>
                <th>Email </th>
                <th>Mobile No.</th>
                <th>Password</th>
                {/* <th>Action</th> */}
              </tr>
            </thead>
            <tbody>
              {filterUsersData.map((admin, index) => (
                <tr key={admin.id} className="bg-white">
                  <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                  <td>
                    <small className="flex-nowrap">
                      {moment(admin.createdAt).format("DD-MMM-YYYY")}
                    </small>
                  </td>
                  <td>
                    <strong
                      className="cursor-pointer text-primary"
                      onClick={() => setUserLogin(admin._id)}
                    >
                      {admin.fullName}
                    </strong>
                  </td>
                  <td>{admin.officeName}</td>
                  <td>
                    <Link className="" to={`mailto:${admin.email}`}>
                      {admin.email}
                    </Link>
                  </td>
                  <td>{admin.mobile}</td>
                  <td>{admin.password}</td>
                  {/* <td>
                    <Link
                      className="btn btn-outline-primary btn-sm py-0"
                      onClick={() => setOpen(true)}
                    >
                      <Eye className="text-sm w-5" />
                    </Link>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </motion.div>
        {/* <div className="flex justify-between mt-4">
          <button
            onClick={prevPage}
            className="px-4 py-2 bg-[#b0c22a] text-white rounded hover:bg-orange-400"
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span className="text-gray-600">
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={nextPage}
            className="px-4 py-2 bg-[#b0c22a] text-white rounded hover:bg-orange-400"
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div> */}

        <Dialog open={open} onClose={setOpen} className="relative z-10">
          <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
          />

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <DialogPanel
                transition
                className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
              >
                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:size-10">
                      <ExclamationTriangleIcon
                        aria-hidden="true"
                        className="size-6 text-red-600"
                      />
                    </div>
                    <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                      <DialogTitle
                        as="h3"
                        className="text-base font-semibold text-gray-900"
                      >
                        Deactivate account
                      </DialogTitle>
                      <div className="mt-2">
                        <p className="text-sm text-gray-500">
                          Are you sure you want to deactivate your account? All
                          of your data will be permanently removed. This action
                          cannot be undone.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                    type="button"
                    onClick={() => setOpen(false)}
                    className=" w-full rounded-md bg-red-600 px-3 text-base font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                  >
                    Deactivate
                  </button>
                  <button
                    type="button"
                    data-autofocus
                    onClick={() => setOpen(false)}
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                  >
                    Cancel
                  </button>
                </div>
              </DialogPanel>
            </div>
          </div>
        </Dialog>
      </div>
    </div>
  );
};

export default UsersData;
